export { TaxonomyI18nModule } from './taxonomy-i18n.module';
export { TaxonomyComponent } from './taxonomy.component';
